const stringToHTML3 = (str) => {
	// If DOMParser is supported, use it
		const parser = new DOMParser();
		const doc = parser.parseFromString(str, 'text/html');
		return doc.body;
};

const formatNumber = (number) => {
  return new Intl.NumberFormat("es-CL").format(number);
}

const centsToCLP = (cents) => formatNumber(Math.round(cents / 100));

const getEffectiveVariantPriceCents = (variant, form) => {
  const override = form.querySelector(`input[name="price-variant-${variant.id}"]`);
  if (override && override.dataset.pricejs) {
    const overrideCents = Math.round(parseFloat(override.dataset.pricejs));
    if (!Number.isNaN(overrideCents) && overrideCents > 0) {
      return Math.min(overrideCents, variant.price);
    }
  }
  return variant.price;
};

const renderShopifySection = async(sections) => {
  try {
    const {
      data: html
    } = await axios.get(`?sections=${sections}`);
    return html;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}

const updateMiniCart = (sectionData) => {
  const cartCount = document.querySelectorAll(".cart-count");

  document.querySelector("#CartContainerPopup").innerHTML = stringToHTML3(sectionData.header).querySelector("#CartContainerPopup").innerHTML;

  cartCount.forEach(element => {
    element.textContent = stringToHTML3(sectionData.header).querySelector(".cart-count").textContent;
  });

  document.querySelector(".minicart-menu .no-items").classList.add("d-none");
  document.querySelector(".minicart-menu .content-form").classList.remove("d-none");
}

const addItemCart = async (id, qyt, section = undefined) => {
  let formData = {
    items: [
      {
       id: id,
       quantity: qyt
      }
    ],
  };

  //Support bundled section rendering
  if (section) {
    formData.sections = section;
  }

  try {
    const { data } = await axios({
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      url: `/cart/add.js`,
      data: JSON.stringify(formData),
    });
    return data;
  } catch (error) {
    throw error;
  }
}

const quickAddOpenPopUp = (product) => {
  const quickAddButton = product.querySelector(".product-card-quick-add");
  const quickAddPopUp = product.querySelector(".add-cart-form");

  quickAddButton.addEventListener("click", ()=> {
    quickAddButton.classList.add("d-none");
    quickAddPopUp.classList.remove("d-none");
  })

  product.addEventListener("mouseleave", ()=> {
    quickAddButton.classList.contains("d-none") && quickAddButton.classList.remove("d-none");
    quickAddPopUp.classList.contains("d-none") || quickAddPopUp.classList.add("d-none");
  });
}

const openVariantPopUp = (product) => {
  const mobileButton = product.querySelector(".mobile-quick-add .product-card-quick-add");
  const quickAddPopUp = product.querySelector(".quick-add-container");
  const form = quickAddPopUp.querySelector(".add-cart-form");
  const closeButton = quickAddPopUp.querySelector(".product-card-close-icon");

  mobileButton.addEventListener("click", ()=> {
    quickAddPopUp.style.setProperty("display", "block", "important");
    form.classList.remove("d-none")
  })

  closeButton.addEventListener("click", ()=> {
    quickAddPopUp.style.removeProperty("display", "block", "important");
    form.classList.add("d-none");
  })
}

const disableButton = (form) => {
  const addCartButton = form.querySelector('button[type="submit"]');
  addCartButton.classList.add("disabled");
}

const showQuickAddStockError = (message, maxQty) => {
  if (typeof window.showStockPopup === 'function') {
    const match = message && message.match(/(\d+)/);
    const parsed = match ? parseInt(match[1], 10) : maxQty;
    window.showStockPopup({ maxQty: parsed });
  } else {
    alert(message || 'No hay más stock disponible para esta variante.');
  }
};

const changePrice = (variant, form) => {

  const priceContainer = form.querySelector(".product-card-price");
  const card = form.closest(".product-item");
  const isWornwear = card && card.dataset.wornwear === "true";

  if (isWornwear) {
    const productId = form.dataset.id.split("-").pop();
    const colorInput = form.querySelector(`[name="color-${productId}"]:checked`);
    const selectedColor = colorInput ? colorInput.value : variant.option1;

    const variantsInput = form.querySelector('input[name="item-variants"]');
    let minCents = null;

    if (variantsInput) {
      const allVariants = JSON.parse(variantsInput.value) || [];
      allVariants.forEach(v => {
        if (v.option1 === selectedColor && v.available) {
          const overrideInput = form.querySelector(`input[name="price-variant-${v.id}"]`);
          let eff = v.price; 
          if (overrideInput && overrideInput.dataset.pricejs) {
            const ov = Math.round(parseFloat(overrideInput.dataset.pricejs)); 
            if (!Number.isNaN(ov) && ov > 0) {
              eff = Math.min(eff, ov);
            }
          }
          if (minCents === null || eff < minCents) minCents = eff;
        }
      });
    }

    if (minCents !== null) {
      const minPriceFormateado = (minCents / 100).toLocaleString('es-ES');
      priceContainer.innerHTML = `<span>Desde: <b class="js-ww-price">$${minPriceFormateado}</b></span>`;
      return;
    }
    // Si no se encontró nada, cae al flujo normal de abajo
  }

  const newPrice = document.querySelector(`input[name="price-variant-${variant.id}"]`);

  if (newPrice != null) {
    const parsedNewPrice = (parseFloat(newPrice.dataset.pricejs)/100);
    const price = variant.price.toString().slice(0, -2).replace('.', '');
    const minPrice = Math.min(
      parseFloat(parsedNewPrice), 
      parseFloat(price)
    );
    const minPriceFormateado = minPrice.toLocaleString('es-ES'); // 'es-ES' para formato CL
    priceContainer.innerHTML = `<span> $${minPriceFormateado} </span> - <span class="product-card-compare-price"> $${parseFloat(variant.compare_at_price.toString().slice(0,-2)).toLocaleString('es-ES', { minimumFractionDigits: 3 }).slice(0,-4)} </span>`;
  } else {
    const price = formatNumber(variant.price.toString().slice(0, -2))
    const compare_at_price = formatNumber(variant.compare_at_price.toString().slice(0, -2))

    if (variant.compare_at_price > variant.price) {
      priceContainer.innerHTML = `<span> $${price} </span>
       - <span class="product-card-compare-price"> $${parseFloat(variant.compare_at_price.toString().slice(0,-2)).toLocaleString('es-ES', { minimumFractionDigits: 3 }).slice(0,-4)} </span>
      `;
    } else {
      priceContainer.innerHTML = `<span> $${compare_at_price} </span>`;
    }
  }
};


const changeBadges = (variant, form) => {
  const badgesContainer = form.querySelector(".product-card-image-tags");
  const badges = document.querySelector(`input[name="badges-variant-${variant.id}"]`)?.value.split(",");

  if (badges.length > 0) {
    if (badgesContainer != null) {
      badgesContainer.innerHTML = '';

      badges.forEach(badge => {
        if (badge != "") {
          const template = `<span class="product-card-tag"> ${badge} </span>`
          badgesContainer.innerHTML += template;
        }
  
      });
    }
  }
}

const changeSizes = (color, form) => {
  // Solo ejecutar si existe el contenedor de tallas (solo existe en sale)
  const sizesContainer = form.querySelector(".product-card-sizes-available .sizes-label");
  
  if (!sizesContainer) return; // Salir si no estamos en template sale
  
  const colorHandle = color.toLowerCase()
    .replace(/\s+/g, '-')  
    .replace(/[()]/g, '')      
    .replace(/[^a-z0-9-_]/g, ''); 
  
  const sizesInput = form.querySelector(`input[name="sizes-color-${colorHandle}"]`);
  
  if (sizesInput) {
    const availableSizes = sizesInput.value;
    
    if (availableSizes && availableSizes.trim() !== "") {
      const formattedSizes = availableSizes.split(',').map(size => size.trim()).join(', ');
      sizesContainer.textContent = `Tallas ${formattedSizes}`;
      sizesContainer.parentElement.style.display = 'block';
    } else {
      sizesContainer.parentElement.style.display = 'none';
    }
  }
}

const changeMainImageHover = (color, form) => {
  const variants = form.querySelector('input[name="item-variants"]');
  const elementMainImage = form.querySelector(".product-card-image .product-card-main-image");
  const elementHoverImage = form.querySelector(".product-card-image .product-card-hover-image");

  const firstColorVariant = JSON.parse(variants.value).filter(
    variant => variant.option1 === color
  )

  // buscar primera variante disponible - no primera variante
  // ya que en la PLP se mostrará la primera variante disponible
  let _firstColorVariantAvailable = null;
  firstColorVariant.forEach(element => {
    if (element.available && _firstColorVariantAvailable === null) {
      _firstColorVariantAvailable = element;
    }
  });

  // según esa primera variante seleccionada, se busca si tiene o no imagen adicional
  // si tiene imagen adicional, se agregará el hover image
  // si no tiene imagen adicional, se agregará el zoom effect
  if (_firstColorVariantAvailable) {
    const hoverUrl = form.querySelector(`.product-images-sources input[name="image-variant-${_firstColorVariantAvailable.id}"]`).value;
    variantImage = _firstColorVariantAvailable.featured_image.src;
    elementMainImage.src = variantImage;
    if (hoverUrl != "") {
      elementMainImage.classList.remove("zoom-efect");
      if (elementHoverImage) {
        elementHoverImage.src = hoverUrl;
        elementHoverImage.classList.remove("display-none");
      }
    } else {
      elementMainImage.classList.add("zoom-efect");
      if (elementHoverImage) {
        elementHoverImage.classList.add("display-none");
      }
    }
  }
}

const validateStock = (variantName, form, color) => {
  const variants = form.querySelector('input[name="item-variants"]');
  const sizeLabels = form.querySelectorAll(".size-swatch");
  const selectedColor = color;

  const selectedVariant = JSON.parse(variants.value).filter(
    variant => variant.title === variantName
  )

  sizeLabels.forEach(sizeLabel => {
    const variantName = `${selectedColor} / ${sizeLabel.dataset.value}`;

    const variant = JSON.parse(variants.value).filter(
      variant => variant.title === variantName
    )

    if (variant.length === 0 || variant[0].available === false ) {
      sizeLabel.classList.add("disabled");
    } else {
      sizeLabel.classList.remove("disabled");
    }
  });
  
  if (selectedVariant.length > 0) {
    form.querySelector('input[name="item-variant_id"]').value = selectedVariant[0].id;
    changeBadges(selectedVariant[0], form);
    changePrice(selectedVariant[0], form);

    return selectedVariant[0].available
  }

  return false
}

const validateVariant = ( color, size, form ) => {
  const nameVariant = `${color} / ${size}`;
  const isAvailable = validateStock(nameVariant, form, color);

  if (isAvailable) {
    const addCartButton = form.querySelector('button[type="submit"]');
    addCartButton.classList.remove("disabled");
  } else {
    disableButton(form);
  }
}

const addPopUpInformation = async (data) => {
  const popUpContainer = document.querySelector(".cart-pop-up-main");

  popUpContainer.querySelector("#product-title").innerText = data.product_title;
  popUpContainer.querySelector("#variant-color").innerText = `${data.options_with_values[0].name?.toLocaleLowerCase()}: ${data.options_with_values[0].value?.split("_")[0].toLocaleLowerCase()} | `
  popUpContainer.querySelector("#variant-size").innerText = `${data.options_with_values[1].name?.toLocaleLowerCase()}: ${data.options_with_values[1].value} | `
  popUpContainer.querySelector("#variant-price").innerText = `$ ${parseFloat(data.price.toString().slice(0,-2)).toLocaleString('es-ES', { minimumFractionDigits: 3 }).slice(0,-4)}`
  popUpContainer.querySelector("#cart_popup_img").src = data.featured_image.url;
  popUpContainer.querySelector("#cart_popup_img").alt = data.featured_image.alt;

  const newPrice = document.querySelector(`input[name="price-variant-${data.variant_id}"]`);

  if (newPrice != null) {
    popUpContainer.querySelector("#variant-price").textContent = newPrice.dataset.price;
  }

  popUpContainer.classList.add("open");
  document.body.style.overflow = 'hidden';
  document.querySelector(".cart-overflow").classList.add("open")

  popUpContainer.querySelector(".close-popup").addEventListener("click", ()=> {
    document.body.style.overflow = 'auto';
    popUpContainer.classList.remove("open");
    document.querySelector(".cart-overflow").classList.remove("open")
  })

  const sectionData = await renderShopifySection("collection");
  
  popUpContainer.querySelector(".pop-up-button").innerHTML = stringToHTML3(sectionData.collection).querySelector(".pop-up-button").innerHTML;
}

const changeCardUrl = (variant, form) => {
  const linkElement = form.querySelector("a")
  const productUrl = new URL(linkElement.href)

  productUrl.searchParams.set('variant', variant.id)

  linkElement.href = productUrl.href
}

const changeImage = (form) => {
  form.addEventListener("change", ()=> {
    const productIdArray = form.dataset.id.split("-");
    const productId = productIdArray[productIdArray.length-1];
    const color = form.querySelector(`[name="color-${productId}"]:checked`).value;

    const variants = form.querySelector('input[name="item-variants"]');
  
    const colorVariants = JSON.parse(variants.value).filter(
      variant => variant.option1 === color
    )
    const firstColorAvailableVariant = colorVariants.filter(variant => variant.available)

    changeBadges(colorVariants[0], form);
    changePrice(colorVariants[0], form);
    changeMainImageHover(color, form);
    changeSizes(color, form);
    changeCardUrl(firstColorAvailableVariant[0], form)
  })
}

const getProductVariant = ( form )=> {

  form.addEventListener("change", ()=> {
    const formData = new FormData(form);

    const productId = formData.get("item-product_id");
    const color = form.querySelector(`[name="color-${productId}"]:checked`).value;
    const size = form.querySelector(`[name="size-${productId}"]:checked`).value;

    validateVariant(color, size, form);
    changeMainImageHover(color, form);
  })

  form.addEventListener("submit", async (e)=> {
  e.preventDefault();
  const formData = new FormData(form);
  const variantId = formData.get("item-variant_id");

  try {
    const dataCart = await addItemCart(variantId, 1, "header");
    updateMiniCart(dataCart.sections);
    addPopUpInformation(dataCart.items[0]);

    // Gestionar el token del carrito en el primer producto
    if (window.CartTokenManager) {
      await window.CartTokenManager.manageCartToken();
    }
  } catch (error) {
    const apiMsg = error?.response?.data?.description || error?.response?.data?.message;
    showQuickAddStockError(apiMsg);
    return;
  }
});
}

const preSelectedVariant = ( form ) => {
  let color, size = null;

  for (const input of form) {
    if (input.checked) {
      if (input.name.includes("color")) {
        color = input.value
      }

      if (input.name.includes("size")) {
        size = input.value
      }
    }
  }

  validateVariant(color, size, form);
}

const initCollection = (product) => {
  const quickAddEnable = product.querySelector('input[name="quickadd_enable"]').value;

  if (quickAddEnable === "true") {
    const productForm = product.querySelector(".product-item-form");

    quickAddOpenPopUp(product);
    openVariantPopUp(product);
    preSelectedVariant(productForm);
    getProductVariant(productForm);
  } else {
    const productForm = product.querySelector(".product-item-form");
    changeImage(productForm);
    const productIdArray = productForm.dataset.id.split("-");
    const productId = productIdArray[productIdArray.length-1];
    const initialColorInput = productForm.querySelector(`[name="color-${productId}"]:checked`);
    
    if (initialColorInput) {
      changeSizes(initialColorInput.value, productForm);
    }
  }
}

const collectionQuickAdd = () => {
  const products = document.querySelectorAll(".product-item");

  products.forEach(product => {
    initCollection(product);
  });
}

collectionQuickAdd();

//Observe new products added
const collectionGridProducts = document.querySelector(".grid-products");
const collectionObserverConfig = { attributes: false, childList: true, subtree: true };

const observeCollectionGrid = (mutationList, gridCollectionsObserver) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach(element => {
        if (element.className === "product-item") {
          initCollection(element);
          if(typeof validateProductSale === 'function') validateProductSale(element);
          if(typeof validateProductNew === 'function') validateProductNew(element);
        }
      });
    }
  }
}

const gridCollectionsObserver = new MutationObserver(observeCollectionGrid);
gridCollectionsObserver.observe(collectionGridProducts, collectionObserverConfig);


// Load more

const getNewProducts = async (url) => {
  try {
    const { data: html } = await axios.get(url);
    return html;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}

const loadMoreProducts = () => {
  const button = document.querySelector(".collection-load-more");
  const loader = document.querySelector(".collection-loader");

  if (button != null) {
    button.addEventListener("click", async (e)=> {
      loader.classList.add("show");
      e.preventDefault();
      const apiUrl = button.dataset.url;
      const gridProducts = document.querySelector(".grid-products");
      const newProductsData = await getNewProducts(apiUrl);
      const newProducts = stringToHTML3(newProductsData).querySelector(".grid-products");
      const loadMoreData = stringToHTML3(newProductsData).querySelector(".collection-load-more");
      const productsPerPage = newProducts.querySelectorAll(".product-item").length;
      const productCounter = document.querySelector("#products-counter");
      const productsCounterTotal = document.querySelector("#products-counter-total");

      let updateTotalCounter = false;
      
      if (loadMoreData != null) {
        gridProducts.insertAdjacentHTML("beforeend", newProducts.innerHTML);
        button.dataset.url = loadMoreData.dataset.url;
        button.href = loadMoreData.href;
      } else {
        gridProducts.insertAdjacentHTML("beforeend", newProducts.innerHTML);
        document.querySelector(".collection-load-more").classList.add("d-none");
        updateTotalCounter = true;
      }
      
      const productImages = gridProducts.querySelectorAll(".product-card-image .product-card-main-image");
      let counter = 0

      if (productsPerPage > 0) {
        productImages.forEach((productImage) => {
          productImage.addEventListener("load", ()=> {
            counter ++
            if(counter === productsPerPage) {
              loader.classList.remove("show");
            }
          })
        });

        let actualProductsCounter = parseInt(productCounter.innerText) + productsPerPage;
        productCounter.innerText  = actualProductsCounter;
        if (updateTotalCounter) {
          productsCounterTotal.innerText = actualProductsCounter;
        }
      } else {
        loader.classList.remove("show");
      }

      titleCardSizes();
    })
  }
}

const titleCardSizes = () => {
  const titleCards = document.querySelectorAll(".grid-products .custom-card")
  const productItem = document.querySelector(".product-card-image");

  titleCards.forEach(card => {
    card.style.height = productItem.offsetHeight + 'px'
  })

}

loadMoreProducts();
titleCardSizes();